import { Modal, Row, Upload } from "antd"
import { Group, Text, Title, notify } from "components/common"
import { useLazyGetS3PresignedQuery, useUpdateS3Mutation } from "features/shared/api"

import animationData from "animation/uploadFileAnimation"
import cx from "clsx"
import { IconText } from "components/custom"
import { t } from "i18next"
import { useRef, useState } from "react"
import Lottie from "react-lottie"
import { fileToBase64 } from "utils"
import theme from "utils/themeVars"
import styles from "../../styles/upload.module.less"
const isValidUrl = urlString => {
  try {
    return Boolean(new URL(urlString))
  } catch (e) {
    return false
  }
}

const onPreview = async file => {
  let src = file.url
  if (isValidUrl(src)) {
    window.location.replace(src)
  } else {
    if (!src) {
      src = await new Promise(resolve => {
        const reader = new FileReader()
        reader.readAsDataURL(file.originFileObj)
        reader.onload = () => resolve(reader.result)
      })
    }
    const image = new Image()
    image.src = src
    const imgWindow = window.open(src)
    imgWindow?.document.write(image.outerHTML)
  }
}

export default function UploadDraggerS3({
  setIsImageUploading = () => {},
  title,
  allowedFiles = "image/png, image/jpeg",
  setFilesList,
  path,
  uploadTitle = t("Click or drag file to this area to upload"),
  uploadDescription = t(
    "Must be in JPG, PNG or PDF file format up till 5 MB Upload all the evidence screenshots, chat conversation or emails that help in your claim."
  ),
  maxCount = 1,
  hideUpload,
  onFileUploadError = () => {},
  onFileUploadSuccess = () => {},
  setLoading = () => {},
  withLocalPath,
  popupPreviewProp,
  extraInformation,
  uploadClass,
  mainClass,
  justLottie,
  allowedFileSize = 10,
  isduplicateFileAllowed,
  multiple,
  itemRenderObj,
  customValidation,
  onRemoveFile = () => {},
  listType = "picture-card",
  showList = true,
  LottieSize,
  customDisplay,
  isAspectRatioRequired = false,
  aspectRatioProps = {},
  darkMode = false,
  ...rest
}) {
  const [getS3] = useLazyGetS3PresignedQuery()
  const [updateS3] = useUpdateS3Mutation()
  const defaultOptions = { loop: true, autoplay: true, animationData: animationData }
  const [file, setFile] = useState({ previewOpen: false })
  // const [files, setFiles] = useState([])
  const files = rest?.fileList
  const s3Ref = useRef()
  const checkFileLength = rest?.fileList?.length || 0

  const handleCancel = () => setFile(prev => ({ ...prev, previewOpen: false }))

  const popupPreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await fileToBase64(file.originFileObj)
    }

    setFile(prev => {
      return {
        ...prev,
        previewImage: file.url || file.preview,
        previewTitle: file.name || file.url?.substring(file.url.lastIndexOf("/") + 1),
        previewOpen: true,
      }
    })
  }

  const onS3UploadSuccess = async (s3Response, file) => {
    setLoading(false)
    setIsImageUploading(false)

    if (withLocalPath) {
      const localPath = await new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
        reader.readAsDataURL(file.file)
      })
      file.onSuccess({ key: s3Response.key, file: file.file, url: s3Response.url, localPath })
      onFileUploadSuccess({ key: s3Response.key, file: file.file, url: s3Response.url, localPath })
    } else {
      onFileUploadSuccess({ key: s3Response.key, file: file.file, url: s3Response.url })
      file.onSuccess({ key: s3Response.key, file: file.file, url: s3Response.url })
    }
  }

  const onUpload = async file => {
    setIsImageUploading(true)
    setLoading(true)
    const fileName = file.file.name
    const s3Response = await getS3({ path: path({ fileName }), id: file.file.uid })
      .unwrap()
      .catch(error => {
        file.onError(error)
        onFileUploadError && onFileUploadError(error, file?.file)
      })
    if (s3Response) {
      await updateS3({ url: s3Response.url, file: file.file, id: file.file.uid })
        .unwrap()
        .then(() => onS3UploadSuccess(s3Response, file))
        .catch(error => {
          setLoading(false)
          setIsImageUploading(false)
          file.onError(error)
          onFileUploadError && onFileUploadError(error, file?.file)
        })
    }
  }
  const beforeUpload = (file, newFileList) => {
    return new Promise((resolve, reject) => {
      const progressEventCount = files?.filter(file => file instanceof ProgressEvent)?.length

      if (newFileList?.findIndex(f => f.uid === file.uid) - progressEventCount + 1 + files?.length > maxCount) {
        return Upload.LIST_IGNORE // this is to stop the override of maxCount when multiple files are being added
      }

      if (file?.size / 1024 / 1024 > allowedFileSize) {
        notify.error(t("File size must be within") + ` ${allowedFileSize} MB!`)
        return Upload.LIST_IGNORE
      } else if (!isduplicateFileAllowed && files?.find(efile => efile.lastModified === file.lastModified)) {
        notify.error(t("Cannot add duplicate file"))
        return Upload.LIST_IGNORE
      } else if (!allowedFiles.split(", ").includes(file.type)) {
        notify.error(t("Invalid file format. Please upload the file in the specified format."))
        return Upload.LIST_IGNORE
      } else if (isAspectRatioRequired) {
        var reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = e => {
          var image = new Image()
          image.src = e.target.result
          image.onload = function () {
            let aspectRatio = (this.naturalWidth / this.naturalHeight).toFixed(2)
            file.isInvalidAspectRatio = !aspectRatioProps.list.some(ratio => ratio == aspectRatio) ? true : false
            file.width = this.naturalWidth
            file.height = this.naturalHeight
            // setFiles(prev => [...prev, file])
            resolve(true)
          }
        }
      } else {
        // setFiles(prev => [...prev, file])
        resolve(true)
      }
    })
  }
  const onRemove = e => {
    if (!!files) {
      // setFiles(file => file.filter(file => file.uid !== e.uid))
      onRemoveFile()
    }
  }

  return (
    <div>
      {!!title && <Title level={3}>{title}</Title>}
      <div
        className={
          checkFileLength < maxCount
            ? cx(styles.uploadOuter, darkMode && styles.darkModeUploader, justLottie && styles.rounded, mainClass)
            : cx(styles.hideUploadArea)
        }
      >
        {extraInformation && extraInformation}
        <Upload.Dragger
          ref={s3Ref}
          multiple={multiple}
          beforeUpload={beforeUpload}
          accept={allowedFiles ? allowedFiles : "image/png, image/jpeg,.pdf,.xls"}
          customRequest={e => onUpload(e)}
          onChange={info => {
            setFilesList(info.fileList.filter(f => f.status !== "error")) //
          }}
          onPreview={popupPreviewProp ? popupPreview : onPreview}
          showUploadList={showList}
          listType={listType}
          maxCount={maxCount}
          className={cx(
            styles.upload,
            rest.disabled && styles.disabled,
            !!checkFileLength && !(checkFileLength < maxCount) && styles.hideUploadArea,
            uploadClass
          )}
          itemRender={(originNode, file, currFileList) => {
            return itemRenderObj
              ? itemRenderObj.itemRender(
                  originNode,
                  file,
                  currFileList,
                  itemRenderObj.itemOnClick,
                  itemRenderObj?.loading
                )
              : originNode
          }}
          onRemove={onRemove}
          {...rest}
        >
          {!hideUpload && checkFileLength < maxCount ? (
            <Group template={!uploadTitle ? "1fr" : "auto 1fr"} gap="24px" style={{ "align-items": "center" }}>
              <Lottie
                options={defaultOptions}
                height={LottieSize ? LottieSize : 56}
                width={LottieSize ? LottieSize : 56}
              />
              {uploadTitle && (
                <Row className="text-left" style={{ gap: 8 }}>
                  <Text color={theme["primary-color"]} block>
                    <span className="semiBold">{uploadTitle}</span>
                  </Text>
                  {uploadDescription && (
                    <IconText
                      icon="BsInfo"
                      title={uploadDescription}
                      iconProps={{
                        style: { color: "#707070" },
                        hasBackground: true,
                        size: "0.5em",
                        iconContainerStyle: { marginTop: 4, padding: 0, "--icon-bg-color": "#E6E6E6" },
                      }}
                      style={{ alignItems: "flex-start", "--typography-color": "#9D9D9D", fontSize: 12, gap: 8 }}
                    />
                  )}
                </Row>
              )}
            </Group>
          ) : null}
        </Upload.Dragger>
        {customDisplay && customDisplay()}
        {popupPreviewProp && (
          <Modal open={file.previewOpen} title={file.previewTitle} footer={null} onCancel={handleCancel}>
            <img alt={rest.modalImgAlt} style={{ width: "100%" }} src={file.previewImage} />
          </Modal>
        )}
      </div>
    </div>
  )
}
